module.exports = __webpack_public_path__ + "img/python.22f98287.png";